// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperNewsStory-cls1___cf47952a59927111f4c{/*!*/}.PaperNewsStory-cls2___bbf5ac2ce6f3c9c5ea3{font-weight:800;margin:0 0 8px 0}.PaperNewsStory-cls2___bbf5ac2ce6f3c9c5ea3.PaperNewsStory-variant-dense___4764d1416cce6652aea{font-family:\"DM Sans\";font-family:var(--type-font-family-sans-serif, \"DM Sans\");font-weight:600;margin-bottom:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperNewsStory-cls1___cf47952a59927111f4c",
	"cls2": "PaperNewsStory-cls2___bbf5ac2ce6f3c9c5ea3 PaperNewsStory-cls1___cf47952a59927111f4c",
	"variant-dense": "PaperNewsStory-variant-dense___4764d1416cce6652aea"
};
export default ___CSS_LOADER_EXPORT___;
